module.exports = require("./../../_gen/starling/extensions/ParticleSystem");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/extensions/ParticleSystem.js
// module id = 192
// module chunks = 0